<template>
  <van-nav-bar :title="title" :class="isHome?'home':''">
    <template #left v-if="showLeftArrow">
      <i class="iconfont iconfont-houtui" @click="goback"></i>
    </template>
    <template #title>
      <h3>{{title}}</h3>
    </template>
    <template #right>
      <i class="iconfont iconfont-gengduo"></i>
    </template>
  </van-nav-bar>
</template>

<script>
  export default {
    data() {
      return {
        title: '',
        showLeftArrow: false,
        isHome: false,//是不是一级页面
        params:''//参数
      }
    },
    mounted() {
      this.title = this.$route.meta.title;
      this.showLeftArrow = this.$route.meta.url;
      this.isHome = !this.$route.meta.showFooter;
      this.params=!this.$route.query?'':this.$route.query;
    },
    watch: {
      $route: {
        handler() {
          this.title = this.$route.meta.title;
          this.showLeftArrow = this.$route.meta.url;
          this.isHome = !this.$route.meta.showFooter;
          this.params=!this.$route.query?'':this.$route.query;
        }
      }
    },
    methods: {
      goback() {
        if(this.params){
          this.$router.go(-1);
        }
        else {
          this.$router.push(this.showLeftArrow)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .home {
    background: #09a5bb;

    * {
      color: white
    }
  }
</style>
